import { render, staticRenderFns } from "./Foo.vue?vue&type=template&id=27fb9e24&scoped=true"
import script from "./Foo.vue?vue&type=script&lang=js"
export * from "./Foo.vue?vue&type=script&lang=js"
import style0 from "./Foo.vue?vue&type=style&index=0&id=27fb9e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb9e24",
  null
  
)

export default component.exports